import { render, staticRenderFns } from "./LicencesWebForm.vue?vue&type=template&id=bdcbe530&scoped=true"
import script from "./LicencesWebForm.vue?vue&type=script&lang=js"
export * from "./LicencesWebForm.vue?vue&type=script&lang=js"
import style0 from "./LicencesWebForm.vue?vue&type=style&index=0&id=bdcbe530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcbe530",
  null
  
)

export default component.exports